import React from 'react';
import DesktopItem from '../Item';
import numeral from 'numeral';
import styled from '@emotion/styled';

import DisplayMoreWrapper from '../../../common/DisplayMoreWrapper';
import { BatchAccountingInfoDesktop } from '../BatchAccountingInfoBlock';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory, useParams } from 'react-router-dom';
import {
  fetchCancelSupply,
  fetchCopySupply,
  fetchRefreshSupply,
} from '../../../../actions/supplies';
import { useDispatch } from 'react-redux';
import { showModal } from '../../../../actions/modal';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';
import { DocumentsTabsWrapper } from '../../../Documents/styled';
import { SUPPLIES_PAGE_TABS, SUPPLIES_TABS_NAME } from '../../../../config';

const Wrapper = styled('div')`
  position: relative;

  .supply-data {
    text-align: center;
  }

  .add-attribute {
    cursor: pointer;
  }

  .add-order {
    color: #7e57c2;
    cursor: pointer;
  }

  .dropdown-menu {
    position: absolute;
    will-change: transform;
    top: 0px;
    left: 0px;
    transform: translate3d(0px, 35px, 0px);

    .dropdown-item {
      cursor: pointer;
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  .bootstrap-table {
    .table {
      margin-bottom: 0;
    }

    .image-td {
      width: 35px;
      padding-right: 5px !important;
      padding-left: 5px !important;

      .image-block {
        width: 25px !important;
        height: 25px !important;
      }
    }

    .item-name {
      font-weight: 700;
      color: #343a40;
    }

    .item-article {
      font-size: 10px;
      color: #72747b;
    }

    .item-subname {
      font-size: 10px;
      color: #98a6ad;
    }

    .item-price-quantity {
      white-space: nowrap;
    }

    .item-price-quantity.item-price-quantity-gray {
      color: #343a40;
    }

    .item-price-quantity.item-price-quantity-red {
      color: #e61610;
      font-weight: 500;
    }

    .item-price-quantity-editable {
      color: #7e57c2;
      cursor: pointer;
    }

    .item-remove {
      cursor: pointer;
    }
  }

  .bottom-block {
    border-top: 1px solid #dee2e6;
    padding-top: 15px;
    margin: 0;

    .add-item {
      color: #7e57c2;
      cursor: pointer;
    }

    .items-total {
      > div {
        margin-bottom: 5px;
      }
    }
  }

  .table-scroll {
    overflow-x: auto;
  }

  .admin-button {
    display: block;
    padding: 7px 9px 7px 7px;
    margin-top: 5px;
    color: #f245d6;
    font-weight: 700;

    &:hover {
      cursor: pointer;
      background-color: #f8f9fa;
    }
  }

  @media (max-width: 422px) {
    .excel-import {
      margin-bottom: 20px;
    }
  }

  .nav-tabs-orders {
    top: -43px !important;
  }
`;

const DesktopLayout = (props) => {
  const {
    orderSaved,
    currentSupply,
    isManualSupply,
    handleConfirmSupply,
    handleConfirmSupplyDifference,
    handleCmpletedSupply,
    isSupplyClosed,
    handleReturnToCompletionSupply,
    setShowActions,
    handleExportSupply,
    handleImportItems,
    showActions,
    batchAccInfoItemIndex,
    showBatchAccInfo,
    handleSetFactToPlanQuantity,
    currentWarehouse,
    setQuantityFactChange,
    handleAddItemsManually,
    total,
    handleEditSupplyOrder,
    defaultReserve,
    hasRelatedOrder,
    shouldDisplayAddSupply,
    activeTab,
    batchAccountingDataKey,
    handleSwitchTab,
    getSuppliesByActiveTab,
  } = props;

  const { t } = useAutoTranslation();

  const [loadingCopy, setLoadingCopy] = useState(false);
  const { id: supplyId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const adminPanel = localStorage.getItem('adminPanel');

  const handleCopySupply = async () => {
    setLoadingCopy(true);
    if (supplyId) {
      await dispatch(fetchCopySupply(supplyId))
        .then((res, rej) => {
          toast.info(`${t('Поставка')} ${supplyId} ${'успешно скопирован'}`);
          history.push(res.orderId);
        })
        .catch((error) => {
          error.data.errors.forEach((e) => {
            toast.error(e.message);
          });
        });
    }
    setLoadingCopy(false);
  };

  const handleRefreshSupply = async () => {
    await dispatch(fetchRefreshSupply(supplyId))
      .then(() => {
        toast.info(`${t('Поставка')} ${supplyId} ${t('успешно обновлена')}`);
      })
      .catch((error) => {
        error.data.errors.forEach((e) => {
          toast.error(e.message);
        });
      });
  };

  const handleCancelSupply = async () => {
    dispatch(showModal('ConfirmCancelSupplie', { supplyId }));
  };

  const shouldDisplayOrderColumn = !defaultReserve || (defaultReserve && hasRelatedOrder);

  return (
    <Wrapper className="card-box">
      {batchAccInfoItemIndex !== null ? (
        <BatchAccountingInfoDesktop
          itemIndex={batchAccInfoItemIndex}
          currentSupply={currentSupply}
          activeTab={activeTab}
          batchAccountingDataKey={batchAccountingDataKey}
        />
      ) : null}

      <div className="row head-row">
        <div className="col-2">
          <h4 className="header-title">{t('Поставка')}</h4>
        </div>
        <div className="col-10 text-right">
          {orderSaved && currentSupply.status === 'NEW' && !isManualSupply ? (
            <button className="btn btn-warning" onClick={handleConfirmSupply}>
              {t('Подтвердить')}
            </button>
          ) : null}
          {orderSaved && currentSupply.status === 'DIFFERENCE' ? (
            <button className="btn btn-warning" onClick={handleConfirmSupplyDifference}>
              {t('Подтвердить расхождения')}
            </button>
          ) : null}
          {orderSaved &&
          isManualSupply &&
          (currentSupply.status === 'NEW' ||
            currentSupply.status === 'READY_TO_TAKE_IN' ||
            currentSupply.status === 'TAKE_IN_PROCESS') ? (
            <button className="btn btn-success" onClick={handleCmpletedSupply}>
              {t('Поставка принята')}
            </button>
          ) : null}
          {orderSaved && isManualSupply && isSupplyClosed ? (
            <button className="btn btn-secondary" onClick={handleReturnToCompletionSupply}>
              <i className="fe-corner-up-left"></i> {t('Возврат на приемку')}
            </button>
          ) : null}

          {!isSupplyClosed ? (
            <button className="btn btn-light ml-1 excel-import" onClick={handleImportItems}>
              <i className="fe-arrow-up" />
              {t('Импорт из Excel')}
            </button>
          ) : null}

          <div className={`btn-group ml-1 ${showActions ? 'show' : ''}`}>
            <button
              type="button"
              className="btn btn-light dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={() => setShowActions(!showActions)}
            >
              {t('Действия')}
              <i className="mdi mdi-chevron-down" />
            </button>
            <div
              className={`dropdown-menu ${showActions ? 'show' : ''}`}
              x-placement="bottom-start"
              onClick={() => setShowActions(false)}
            >
              {orderSaved &&
              isManualSupply &&
              (currentSupply.status === 'NEW' ||
                currentSupply.status === 'READY_TO_TAKE_IN' ||
                currentSupply.status === 'TAKE_IN_PROCESS') ? (
                <div className="dropdown-item" onClick={handleSetFactToPlanQuantity}>
                  {t('Заполнить по плану')}
                </div>
              ) : null}
              <div className="dropdown-item" onClick={handleExportSupply}>
                <i className="" />
                {t('Выгрузить отчёт по приёмке')}
              </div>
              <div className="dropdown-item" onClick={handleCopySupply}>
                {t('Копировать')}
              </div>
              {adminPanel === 'true' && (
                <div className="dropdown-item admin-button" onClick={handleRefreshSupply}>
                  <i className="fe-rotate-ccw" /> {t('Обновить поставки')}
                </div>
              )}
              {adminPanel === 'true' && (
                <div className="dropdown-item admin-button" onClick={handleCancelSupply}>
                  <i className="fe-trash-2" /> {t('Отменить')}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="bootstrap-table mt-4">
        <DocumentsTabsWrapper>
          <ul className="nav nav-tabs-orders" style={{ flexWrap: 'nowrap' }}>
            {SUPPLIES_PAGE_TABS.map((tab) => (
              <li className="nav-item" key={tab.id}>
                <div
                  data-toggle="tab"
                  aria-expanded="true"
                  className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => handleSwitchTab(tab.id)}
                >
                  <div className="d-flex flex-row">
                    <div className="nav-link-icon">
                      <i className={tab.icon} />
                    </div>
                    <div className="tab-title">{t(tab.title)}</div>
                  </div>
                </div>
                <div className={`nav-link-after ${activeTab === tab.id ? 'active' : ''}`} />
              </li>
            ))}
          </ul>
        </DocumentsTabsWrapper>
        <div className="fixed-table-container">
          <div className="fixed-table-body table-scroll">
            {currentSupply ? (
              <DisplayMoreWrapper
                array={getSuppliesByActiveTab()}
                isTable
                thead={
                  <thead className="thead-light">
                    <tr>
                      <th className="image-td"></th>
                      <th>{t('Номенклатура')}</th>
                      <th className="supply-data">{t('Тег')}</th>
                      <th>{t('Партия')}</th>
                      <th className="supply-data">{t('Цена закупки')}</th>
                      <th className="supply-data">{t('НДС')}</th>
                      <th className="supply-data">{t('Сумма')}</th>
                      <th className="supply-data">{t('Кол-во план')}</th>
                      {activeTab === SUPPLIES_TABS_NAME.FACT && (
                        <>
                          <th className="supply-data">{t('Кол-во факт')}</th>
                          <th className="supply-data">{t('Кол-во брак')}</th>
                        </>
                      )}
                      {activeTab === SUPPLIES_TABS_NAME.PLAN && shouldDisplayOrderColumn && (
                        <th>{t('Заказ')}</th>
                      )}
                      {activeTab === SUPPLIES_TABS_NAME.PLAN && <th></th>}
                    </tr>
                  </thead>
                }
              >
                {({ item, itemIndex }) => (
                  <DesktopItem
                    key={`${item.productId}=${item.variantId}`}
                    item={item}
                    itemIndex={itemIndex}
                    currentWarehouse={currentWarehouse}
                    setQuantityFactChange={setQuantityFactChange}
                    handleEditSupplyOrder={handleEditSupplyOrder}
                    defaultReserve={defaultReserve}
                    hasRelatedOrder={hasRelatedOrder}
                    showBatchAccInfo={showBatchAccInfo}
                    activeTab={activeTab}
                    batchAccountingDataKey={batchAccountingDataKey}
                  />
                )}
              </DisplayMoreWrapper>
            ) : null}
          </div>
        </div>
      </div>

      <div className="row bottom-block">
        <div className="col-6" style={{ paddingLeft: 0 }}>
          {shouldDisplayAddSupply && activeTab === SUPPLIES_TABS_NAME.PLAN ? (
            <div className="add-item" onClick={handleAddItemsManually}>
              + {t('Новая позиция')}
            </div>
          ) : null}
        </div>
        <div className="col-6" style={{ paddingRight: 0 }}>
          <div className="items-total text-lg-right">
            <div>
              {t('Всего товаров')}: {currentSupply?.totalQuantity} {t('шт')}. | Сумма:{' '}
              {numeral(currentSupply?.totalOrderSum).format('0,0.00')}
            </div>
            <div>
              {t('В том числе НДС')}: {numeral(currentSupply?.totalVATSum).format('0,0.00')}
            </div>

            {!shouldDisplayAddSupply ? ( // Отображается начиная со статуса "Идет приемка"/TAKE_IN_PROCESS
              <>
                <div className="mt-2">
                  <strong>{t('Фактически принято')}:</strong>
                </div>
                <div>
                  {t('Всего товаров')}: {currentSupply?.totalFactQuantity} {t('шт')}. | {t('Сумма')}
                  : {numeral(currentSupply?.totalFactOrderSum).format('0,0.00')}
                </div>
                <div>
                  {t('В том числе НДС')}: {numeral(currentSupply?.totalFactVATSum).format('0,0.00')}
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default DesktopLayout;
